import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { TabSideBaseClass } from "../../common/tab-side/tab-side.component"
import { Tabs } from "../../common//tabs/tabs.enum";
import { TabsService } from "../../common//tabs/tabs.service";
import { KoblingerService, ServerSystem } from "../../koblinger/koblinger.service";
import { ModalService } from "../../services/modal.service";
import { TilgangService } from "../../services/tilgang.service";
import { SystemStatusEnum } from "../../itsystemer/itsystemer.service";
import { throwError } from "rxjs";

@Component({
  selector: "app-systemer-tab",
  templateUrl: "./serversystemer-tab.component.html"
})
export class ServerSystemerTabComponent extends TabSideBaseClass<ServerSystem> {

  utgattSystem = SystemStatusEnum.Utgatt;

  tabName(): Tabs {
    return Tabs.systemer;
  }

  constructor(tabsService: TabsService, service: KoblingerService, tilgangService: TilgangService, route: ActivatedRoute, modal: ModalService, router: Router) {
    super(tabsService, service, tilgangService, modal, route, router);
  }

  loaderObservable(service: KoblingerService, id: number): Observable<ServerSystem[]> {
    return service.getServerSystemForServer(id);
  }

  pageLinkAccess(service: TilgangService): Observable<boolean> {
    return service.getGlobalRoles().pipe(map(val => val.itsystemer.listAccess));
  }

  removeObservable(service: KoblingerService, item: ServerSystem): Observable<object> {
    // Kommentert ut 16.april 2026. Skal ikke ha denne funksjonaliteten her lenger.
    //return service.removeServerSystemForServer(item.serverId, item.systemId);
    return throwError(() => new Error('removeObservable er avviklet'));
  }


  compareFn(first: ServerSystem, second: ServerSystem): number {
    if (first.system?.systemstatusId == second.system?.systemstatusId) return 0;
    if (first.system?.systemstatusId < second.system?.systemstatusId) return -1;
    else return 1;
  }

  
  kobleTil(): void {
    /*
    // Kommentert ut 16.april 2026. Skal ikke ha denne funksjonaliteten her lenger.
    this.modal.velgSystem().then(system => {
      this.modal.velgServer().then(server => {

        if (this.liste.some(t => t.systemId === system.systemId && t.serverId === server.serverId)) {
          this.modal.warning(`${system.navn} med server ${server.navn} er allerede koblet til server`, "Kobling feilet");
          return;
        }

        const serverSystem: ServerSystem = { serverId: this.id, systemId: system.systemId };
        this.service.postServerSystemForServer(serverSystem).toPromise().then(() => {
          this.modal.success("System koblet til server", "kobling vellykket");
          this.load();
        });
      });
    });
    */
  }
  
}
